var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrupRehberlik = function SvgGrupRehberlik(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4330_4097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.215 145.796C128.497 145.796 150.613 123.68 150.613 96.3981C150.613 69.1163 128.497 47 101.215 47C73.9336 47 51.8174 69.1163 51.8174 96.3981C51.8174 123.68 73.9336 145.796 101.215 145.796Z",
    fill: "#2B81FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 219.825C12 183.45 41.4883 153.961 77.8641 153.961H123.969C160.345 153.961 189.833 183.45 189.833 219.825C189.833 238.013 175.089 252.757 156.901 252.757H44.932C26.7442 252.757 12 238.013 12 219.825Z",
    fill: "url(#paint0_linear_4330_4097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.517 171.38C241.336 171.38 258.212 154.503 258.212 133.685C258.212 112.867 241.336 95.99 220.517 95.99C199.699 95.99 182.822 112.867 182.822 133.685C182.822 154.503 199.699 171.38 220.517 171.38Z",
    fill: "#2B81FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.438 227.871C152.438 200.114 174.941 177.612 202.698 177.612H237.88C265.638 177.612 288.14 200.114 288.14 227.871C288.14 241.75 276.889 253.001 263.01 253.001H177.568C163.69 253.001 152.438 241.75 152.438 227.871Z",
    fill: "url(#paint1_linear_4330_4097)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4330_4097",
    x1: 189.802,
    y1: 153.966,
    x2: 105.936,
    y2: 304.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4330_4097",
    x1: 288.117,
    y1: 177.615,
    x2: 224.119,
    y2: 292.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4330_4097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
};
export default SvgGrupRehberlik;